// extracted by mini-css-extract-plugin
module.exports = {"iconTextCell":"IconTextCell_iconTextCell__CPo0n"};